document.addEventListener('DOMContentLoaded', function() {
  const listItems = document.querySelectorAll('.scroll-list__item.js-scroll-list-item');
  let lastVisibleItem = null; // Track the last fully visible item

  const handleListItemVisibility = function() {
    const viewportHeight = window.innerHeight;
    const scrollPosition = window.scrollY + (viewportHeight / 2); // Adjusted scroll position for center visibility

    let isVisible = false; // Track if any item is fully visible

    listItems.forEach(listItem => {
      const listItemRect = listItem.getBoundingClientRect();

      // Check if more than 50% of the item is visible in the viewport
      const itemTop = listItemRect.top + window.scrollY;
      const itemBottom = listItemRect.bottom + window.scrollY;
      const isFullyVisible = (itemTop <= scrollPosition && itemBottom >= scrollPosition);

      // Toggle the full-opacity class based on visibility
      listItem.classList.toggle('full-opacity', isFullyVisible);

      // Track the last fully visible item
      if (isFullyVisible) {
        lastVisibleItem = listItem;
        isVisible = true;
      }
    });

    // If no item is fully visible, ensure all items have base opacity
    if (!isVisible) {
      listItems.forEach(listItem => {
        listItem.classList.remove('full-opacity');
      });
    }

    // Ensure the last item remains at full opacity
    if (lastVisibleItem) {
      listItems.forEach(item => {
        if (item !== lastVisibleItem) {
          item.classList.remove('full-opacity');
        }
      });
      lastVisibleItem.classList.add('full-opacity');
    }
  };

  // Call the function initially to set opacity on page load
  handleListItemVisibility();

  // Attach event listener for continuous updates on scroll
  window.addEventListener('scroll', handleListItemVisibility);

  // Function to scroll to the next item with scroll snapping effect
  const scrollToNextItem = function(event) {
    const currentVisibleIndex = Array.from(listItems).indexOf(lastVisibleItem);
    if (currentVisibleIndex < listItems.length - 1) {
      const nextItem = listItems[currentVisibleIndex + 1];
      nextItem.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
    }
  };

  // Attach event listener to scroll to the next item on click or touch
  listItems.forEach(item => {
    item.addEventListener('click', scrollToNextItem);
  });
});
